module.exports = __webpack_public_path__ + "img/tiktok_white.0cce8758.png";